import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AlertTriangleIcon, CheckCircleBrokenIcon, InfoCircleIcon, XCloseIcon } from '@prophecy/icons';
import styled from 'styled-components';
import { Button } from '../Button';
import { StackItem } from '../Layout';
import { renderWithTooltip } from '../Tooltip';
import { LabelWithHint } from '../Typography/LabelWithHint';
import { StyledAlert } from './styled';
import { tokens } from './tokens';
import { Variant } from './types';
const IconMap = {
    warning: _jsx(AlertTriangleIcon, { type: 'default', color: tokens.Alert.warning.iconColor }),
    error: _jsx(InfoCircleIcon, { type: 'default', color: tokens.Alert.error.iconColor }),
    info: _jsx(InfoCircleIcon, { type: 'default', color: tokens.Alert.info.iconColor }),
    success: _jsx(CheckCircleBrokenIcon, { type: 'default', color: tokens.Alert.success.iconColor })
};
const CloseButton = styled(Button) `
  self-align: flex-start;
`;
export function Alert({ variant = Variant.warning, banner, children, icon = IconMap[variant], showIcon = true, closable, onClose, tooltip, hint, 'data-test-id': dataTestId = 'alert', ...restProps }) {
    let alertUI = (_jsxs(StyledAlert, { variant: variant, direction: 'horizontal', alignY: 'top', banner: banner, role: 'alert', ...restProps, "data-test-id": dataTestId, "data-state": variant, children: [showIcon && _jsx("span", { children: icon }), _jsx(StackItem, { grow: '1', children: children }), closable && (_jsx("span", { children: _jsx(CloseButton, { variant: 'plain', icon: _jsx(XCloseIcon, { type: 'default' }), onClick: onClose, "aria-label": 'Close alert', "data-test-id": 'alert-close-button' }) }))] }));
    if (tooltip) {
        alertUI = _jsx(_Fragment, { children: renderWithTooltip(alertUI, tooltip) });
    }
    if (hint) {
        alertUI = _jsx(LabelWithHint, { hint: hint, children: alertUI });
    }
    return alertUI;
}
